/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/sections/product/reviews-cards.js":
/*!*******************************************************!*\
  !*** ./zrc/scripts/sections/product/reviews-cards.js ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/swiper.esm.js\");\n/* eslint-disable @babel/object-curly-spacing */\n\nconst nameCustomElement = \"main-product-reviews-cards\";\nclass MainProductReviewsCards extends window.HTMLElement {\n  connectedCallback() {\n    this.configSwipper();\n    // this.configHeightCarousel();\n    // this.handleEvents();\n  }\n\n  // handleEvents() {\n  //   this.resizeTimer = null;\n\n  //   window.addEventListener(\"resize\", () => {\n  //     window.clearTimeout(this.resizeTimer);\n\n  //     this.resizeTimer = window.setTimeout(() => {\n  //       this.configHeightCarousel();\n  //     }, 100);\n  //   });\n  // }\n\n  configSwipper() {\n    const $sliderContainer = this.querySelector(\".mp-reviews-cards-items\");\n    const $prevButton = this.querySelector(`.mp-reviews-cards-arrow.prev`);\n    const $nextButton = this.querySelector(`.mp-reviews-cards-arrow.next`);\n    new swiper__WEBPACK_IMPORTED_MODULE_0__.default($sliderContainer, {\n      modules: [swiper__WEBPACK_IMPORTED_MODULE_0__.Navigation, swiper__WEBPACK_IMPORTED_MODULE_0__.Mousewheel, swiper__WEBPACK_IMPORTED_MODULE_0__.FreeMode],\n      loop: false,\n      slidesPerView: \"auto\",\n      centerInsufficientSlides: true,\n      // autoHeight: true,\n      navigation: {\n        prevEl: $prevButton,\n        nextEl: $nextButton\n      },\n      mousewheel: {\n        forceToAxis: true\n      },\n      freeMode: {\n        enabled: true,\n        momentumBounce: false\n      },\n      breakpoints: {\n        1: {\n          allowTouchMove: true,\n          mousewheel: {\n            enabled: false\n          }\n        },\n        1024: {\n          allowTouchMove: false,\n          mousewheel: {\n            enabled: true\n          }\n        }\n      }\n    });\n  }\n\n  // configHeightCarousel() {\n  //   const $items = this.querySelectorAll(\".mp-reviews-cards-item\");\n  //   this.style.setProperty(\"--max-item-height\", \"auto\");\n\n  //   let maxHeight = 0;\n  //   $items.forEach(($item) => {\n  //     const itemHeight = $item.offsetHeight;\n  //     if (itemHeight > maxHeight) {\n  //       maxHeight = itemHeight;\n  //     }\n  //   });\n\n  //   this.style.setProperty(\"--max-item-height\", `${maxHeight}px`);\n  // }\n}\n\nif (!window.customElements.get(nameCustomElement)) {\n  window.customElements.define(nameCustomElement, MainProductReviewsCards);\n}//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///./zrc/scripts/sections/product/reviews-cards.js\n");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"main-product-reviews-cards": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/sections/product/reviews-cards.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkgetmore_workflow"] = globalThis["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;